import Link from "next/link";

interface CTAProps {
  title: string;
  description?: string;
  buttonText: string;
  href: string;
}

export default function CTA({
  title,
  description,
  buttonText,
  href,
}: CTAProps) {
  return (
    <section className="my-12 rounded-xl bg-gray-100 p-6 text-center">
      <h3 className="mb-2 text-xl font-bold">{title}</h3>

      {description && (
        <p className="mb-4 text-sm text-gray-700">{description}</p>
      )}

      <Link
        href={href}
        className="inline-flex items-center justify-center rounded-md bg-blue-600 px-6 py-2 text-sm font-medium text-white transition hover:bg-blue-700"
      >
        {buttonText}
      </Link>
    </section>
  );
}
